import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

const MakeGetRequest = ({
  requestType = "GET",
  route = "",
  errorCodeRedirect = null,
  forceToken = null,
} = {}) => {
  const navigate = useNavigate();

  const apiUrl = import.meta.env.VITE_API_URL;
  const apiRoute = route;

  const token = useSelector((state) => state.token);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      // Auth check, if token is needed
      if (forceToken && !token) {
        setError("No Token");
        return;
      }

      try {
        const apiEndpoint = `${apiUrl}${apiRoute}`;
        const response = await axios({
          method: requestType,
          url: apiEndpoint,
          withCredentials: true,
        });
        setData(response.data);
      } catch (error) {
        if (error.response?.status === errorCodeRedirect) {
          // Unauthorized, redirect user
          navigate("/404");
        }
        setError(error.response?.data?.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    apiUrl,
    apiRoute,
    requestType,
    token,
    loading,
    errorCodeRedirect,
    navigate,
    forceToken,
  ]);

  return { data, error, loading };
};

export default MakeGetRequest;
